import { PlaceholderPage } from './PlaceholderPage';

export const WorkerListPage = () => <PlaceholderPage title="Worker List" />;
